import "core-js/modules/es.array.push.js";
export default {
  props: ['data', 'visible', 'again'],
  data() {
    return {
      form: {
        name: '航空意外险'
      }
    };
  },
  watch: {
    visible(newV) {
      if (newV) {
        this.getDetail();
      }
    }
  },
  methods: {
    async getDetail() {
      Object.assign(this.form, this.data);
    },
    async toPay() {
      let position = this.again ? 'repayment' : 'payment';
      this.$router.push({
        name: 'toPay',
        params: {
          customerId: this.form.customerId,
          batchPolicyId: this.form.id,
          position
        }
      });
      this.$emit('cancel');
    }
  }
};